import React, {Component} from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';

import {BaasicFieldDropdownTemplate} from 'themes/components';

@observer
class BaasicFieldDropdown extends Component {
    render() {
        const { disabled, focused, field, store, multi, className, itemRender, valueRender, tagRender, labelDisplayed, allowEmpty, autoClose, showChangeFlag, previousValue, toolTipPlace, isNiko, nikoInputData, trimOnPaste  /*customRef*/ } = this.props;
        return (
            <BaasicFieldDropdownTemplate /*customRef={customRef}*/ focused={focused} disabled={disabled} store={store} field={field} multi={multi} className={className} itemRender={itemRender}
                valueRender={valueRender} tagRender={tagRender} labelDisplayed={labelDisplayed} allowEmpty={allowEmpty} autoClose={autoClose} showChangeFlag={showChangeFlag} previousValue={previousValue}
                toolTipPlace={toolTipPlace} isNiko={isNiko} nikoInputData={nikoInputData} trimOnPaste={trimOnPaste} />
        );
    }
}

BaasicFieldDropdown.propTypes = {
    field: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    multi: PropTypes.bool,
    className: PropTypes.string,
    itemRender: PropTypes.any,
    valueRender: PropTypes.any,
    tagRender: PropTypes.any,
    labelDisplayed: PropTypes.bool,
    disabled: PropTypes.bool,
    allowEmpty:PropTypes.bool,
    focused:PropTypes.bool,
    autoClose:PropTypes.bool,
    showChangeFlag: PropTypes.bool,
    previousValue: PropTypes.string,
    toolTipPlace: PropTypes.string,
    isNiko: PropTypes.bool,
    nikoInputData: PropTypes.any,
    trimOnPaste: PropTypes.bool,
    //customRef:PropTypes.any
};

export default BaasicFieldDropdown;
